import Vue from 'vue';
import Vuex from 'vuex';
import loading from './modules/loading'
import app from './modules/app'
import lesson from './modules/lesson'
import meetingStore from './modules/meeting.store';
import userStore from './modules/user.store';
import getters from './getters'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app,
        loading,
        lesson,
        meetingStore,
        userStore
    },
    getters,
    state: {
        userInfo: null,
        loginBtnShow: true,
        dialogVisible: false,
        themeData: null,
        institutionId: null,
        changeDialogVisible: false,
        scratchLogin: null,
        scratchLogout: null,
        pythonLogin: null,
        callback: null,
        lessonDialogShow: false
    },
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setLoginBtnShow(state, bool) {
            state.loginBtnShow = bool;
        },
        setDialogVisible(state, bool) {
            state.dialogVisible = bool;
        },
        setChangeDialogVisible(state, bool) {
            state.changeDialogVisible = bool;
        },
        setThemeData(state, theme) {
            state.themeData = theme;
        },
        setInstitutionId(state, id) {
            state.institutionId = id;
        },
        setScratchLogin(state, fn) {
            state.scratchLogin = fn;
        },
        setScratchLogout(state, fn) {
            state.scratchLogout = fn;
        },
        setPythonLogin(state, fn) {
            state.pythonLogin = fn;
        },
        setUserInfowxInfo(state, params) {
            state.userInfo.wxHeadImg = params.wxHeadImg;
            state.userInfo.wxNickname = params.wxNickname;
        },
        setCallback(state, callback) {
            state.callback = callback;
        },
        setLessonDialogShow(state, bool) {
            state.lessonDialogShow = bool;
        },
    }
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js